/**
 * Add a loading spinner effect to a button
 * @param {HTMLElement} button
 */
export const loadingSpinner = (button) => {
  if (!button) return;
  const spinner = button.querySelector(".loading-overlay__spinner");
  if (spinner) spinner.classList.remove("hidden");
  button.classList.add("loading");
  setTimeout(() => {
    if (spinner) spinner.classList.add("hidden");
    button.classList.remove("loading");
  }, 2000);
};
